module.exports = __webpack_public_path__ + "static/media/incorrect-icon.2707e175.svg";